(function () {
    var input = document.getElementById('investmentAmount');
    var table = document.getElementById('assetDistributionTable');
    var fundSelectDropdown = document.getElementById('fundSelectDropdown');
    var investmentTypeDropdown = document.getElementById('investmentTypeDropdown');
    if (!input || !table || !fundSelectDropdown || !investmentTypeDropdown) return;

    var config = window.portalLandingConfig || {};
    var getFundDataUrl = config.getFundDataUrl || '';
    var getUnderlyingHoldingsUrl = config.getUnderlyingHoldingsUrl || '';

    var underlyingWrapper = document.querySelector('.portal-landing__underlying-holdings');
    var underlyingTable = document.getElementById('underlyingHoldingsTable');
    var underlyingTbody = underlyingTable ? underlyingTable.querySelector('tbody') : null;
    var underlyingPageId = underlyingWrapper ? underlyingWrapper.dataset.pageId : '';
    var underlyingAsOfDateEl = document.querySelector('.portal-landing__underlying-holdings-as-of-date');
    var currencyFmt = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 });
    var parentNavCurrent = 0;
    var fundValue = '';
    var fundLabelText = '—';
    var investmentTypeValue = 'dollars';
    var investmentTypeText = 'Dollars';

    function setUnderlyingAsOfDate(text) {
        if (!underlyingAsOfDateEl) return;
        if (text) {
            underlyingAsOfDateEl.textContent = text;
            underlyingAsOfDateEl.hidden = false;
        } else {
            underlyingAsOfDateEl.textContent = '';
            underlyingAsOfDateEl.hidden = true;
        }
    }

    function setUnderlyingPlaceholder(text) {
        if (!underlyingTbody) return;
        underlyingTbody.innerHTML = '';
        var tr = document.createElement('tr');
        tr.className = 'row-empty';
        var td = document.createElement('td');
        td.colSpan = 4;
        td.textContent = text;
        tr.appendChild(td);
        underlyingTbody.appendChild(tr);
    }

    function renderUnderlying(rows) {
        if (!underlyingTbody) return;
        underlyingTbody.innerHTML = '';
        if (!rows || !rows.length) {
            setUnderlyingPlaceholder('No underlying holdings available for this fund.');
            return;
        }
        rows.forEach(function (h) {
            var tr = document.createElement('tr');
            [
                h.ticker || '',
                h.securityName || '',
                h.marketValue != null ? currencyFmt.format(h.marketValue) : '—',
                h.weight != null ? Number(h.weight).toFixed(2) + '%' : '—'
            ].forEach(function (val) {
                var td = document.createElement('td');
                td.textContent = val;
                tr.appendChild(td);
            });
            underlyingTbody.appendChild(tr);
        });
    }

    function calculate() {
        var amount = parseFloat(input.value);
        if (isNaN(amount) || amount < 0) amount = 0;

        var totalInvestment = investmentTypeValue === 'units'
            ? amount * parentNavCurrent
            : amount;

        var rows = table.querySelectorAll('tbody tr.row-item');
        var totalMarketValue = 0;
        var totalWeight = 0;

        rows.forEach(function (row) {
            var weight = parseFloat(row.getAttribute('data-weight')) || 0;
            var nav = parseFloat(row.getAttribute('data-nav')) || 0;
            var allocation = totalInvestment * (weight / 100);
            var units = nav > 0 ? allocation / nav : 0;
            var marketValue = units * nav;
            totalMarketValue += marketValue;
            totalWeight += weight;

            row.querySelector('.js-units').textContent = nav > 0 ? units.toFixed(4) : '—';
            row.querySelector('.js-market-value').textContent = marketValue.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
            row.querySelector('.js-pct-assets').textContent = weight.toFixed(2) + '%';
        });

        table.querySelector('.js-total-market-value').innerHTML = '<strong>' + totalMarketValue.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' }) + '</strong>';
        table.querySelector('.js-total-pct-assets').innerHTML = '<strong>' + totalWeight.toFixed(2) + '%</strong>';
    }

    function updateTable(holdings) {
        var tbody = table.querySelector('tbody');
        tbody.querySelectorAll('tr.row-item').forEach(function (row) { row.remove(); });
        var totalRow = tbody.querySelector('tr.row-total');

        holdings.forEach(function (h) {
            var tr = document.createElement('tr');
            tr.className = 'row-item';
            tr.setAttribute('data-weight', h.weight || 0);
            tr.setAttribute('data-nav', h.navCurrent || 0);

            [
                [h.ticker || '', ''],
                [h.fundName || '', ''],
                ['—', 'js-units'],
                [h.navCurrent != null ? Number(h.navCurrent).toFixed(2) : '—', ''],
                ['—', 'js-market-value'],
                ['—', 'js-pct-assets']
            ].forEach(function (col) {
                var td = document.createElement('td');
                td.textContent = col[0];
                if (col[1]) td.className = col[1];
                tr.appendChild(td);
            });

            tbody.insertBefore(tr, totalRow);
        });

        calculate();
    }

    fundSelectDropdown.querySelectorAll('.dropdown-item').forEach(function (item) {
        item.addEventListener('click', function () {
            fundValue = this.dataset.value || '';
            fundLabelText = fundValue ? this.textContent.trim() : '—';
            fundSelectDropdown.querySelector('.dropdown__label').textContent = this.textContent.trim();

            if (!fundValue) {
                parentNavCurrent = 0;
                updateTable([]);
                setUnderlyingPlaceholder('Select a fund to view the underlying holdings.');
                setUnderlyingAsOfDate('');
                return;
            }
            fetch(getFundDataUrl + '?ticker=' + encodeURIComponent(fundValue) + '&_=' + Date.now())
                .then(function (r) { return r.json(); })
                .then(function (data) {
                    parentNavCurrent = data.navCurrent || 0;
                    updateTable(data.holdings || []);
                });
            if (underlyingTbody && underlyingPageId) {
                setUnderlyingPlaceholder('Loading…');
                setUnderlyingAsOfDate('');
                fetch(getUnderlyingHoldingsUrl + '?ticker=' + encodeURIComponent(fundValue)
                    + '&pageId=' + encodeURIComponent(underlyingPageId) + '&_=' + Date.now())
                    .then(function (r) { return r.json(); })
                    .then(function (data) {
                        renderUnderlying(data.holdings || []);
                        setUnderlyingAsOfDate(data.asOfDateText || '');
                    })
                    .catch(function () {
                        setUnderlyingPlaceholder('Unable to load holdings.');
                        setUnderlyingAsOfDate('');
                    });
            }
        });
    });

    investmentTypeDropdown.querySelectorAll('.dropdown-item').forEach(function (item) {
        item.addEventListener('click', function () {
            investmentTypeValue = this.dataset.value;
            investmentTypeText = this.textContent.trim();
            investmentTypeDropdown.querySelector('.dropdown__label').textContent = investmentTypeText;
            calculate();
        });
    });

    input.addEventListener('input', calculate);
    calculate();

    function updatePrintHeader() {
        var amount = parseFloat(input.value);
        var amountLabel = isNaN(amount)
            ? '—'
            : (investmentTypeValue === 'units'
                ? amount.toLocaleString('en-AU') + ' units'
                : amount.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 }));

        document.querySelector('.js-print-fund').textContent = fundLabelText;
        document.querySelector('.js-print-amount').textContent = amountLabel;
        document.querySelector('.js-print-type').textContent = investmentTypeText;
        document.querySelector('.js-print-date').textContent = new Date().toLocaleDateString('en-AU');
    }

    window.addEventListener('beforeprint', updatePrintHeader);

    var exportPdfBtn = document.getElementById('exportPdfBtn');
    if (exportPdfBtn) {
        exportPdfBtn.addEventListener('click', function () {
            updatePrintHeader();
            window.print();
        });
    }

    var exportCsvBtn = document.getElementById('exportCsvBtn');
    if (exportCsvBtn) {
        exportCsvBtn.addEventListener('click', function () {
            var rows = [];
            var exportDate = new Date().toLocaleDateString('en-AU');

            rows.push(['"Fund:"', '"' + fundLabelText.replace(/"/g, '""') + '"']);
            rows.push(['"Investment Amount:"', '"' + input.value + '"']);
            rows.push(['"Investment Type:"', '"' + investmentTypeText + '"']);
            rows.push(['"Date:"', '"' + exportDate + '"']);
            rows.push([]);

            var headers = [];
            table.querySelectorAll('thead th').forEach(function (th) {
                headers.push('"' + th.textContent.trim().replace(/"/g, '""') + '"');
            });
            rows.push(headers);

            table.querySelectorAll('tbody tr').forEach(function (tr) {
                var cells = [];
                tr.querySelectorAll('td').forEach(function (td) {
                    var val = td.textContent.trim().replace(/—/g, '--').replace(/"/g, '""');
                    cells.push('"' + val + '"');
                });
                rows.push(cells);
            });

            var disclaimerEl = document.getElementById('exportDisclaimer');
            if (disclaimerEl) {
                rows.push([]);
                disclaimerEl.textContent.trim().split(/\n+/).forEach(function (line) {
                    line = line.trim();
                    if (line) rows.push(['"' + line.replace(/"/g, '""') + '"']);
                });
            }

            var csv = rows.map(function (r) { return r.join(','); }).join('\r\n');
            var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            var url = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = 'asset-distribution-' + exportDate.replace(/\//g, '-') + '.csv';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        });
    }
})();
